const genColor = (len) => {
    const colors = [];
    let red = 0;
    let green = 0;
    let blue = 0;
    const step = 87;
    let myLength = 0;

    const flags = [];
    for (let i = 0; i < len; i++) {
        flags.push((i ^ 2) % 3);
    }
    while (myLength < len) {
        const flag = flags[myLength];
        if (flag > 1) {
            red += step;
        } else if (flag > 0) {
            green += step;
        } else {
            blue += step;
        }
        red = red % 250;
        green = green % 250;
        blue = blue % 250;
        colors.push(`#${((1 << 24) + (red << 16) + (green << 8) + blue).toString(16).slice(1)}`);
        myLength = colors.length;
    }
    return colors;
};
export const colorsProvider = (num) => {
    return [
        '#FF4962',
        '#35B7EA',
        '#51C793',
        '#FF9149',
        '#9BBCFF',
        '#E1A143',
        '#A00034',
        '#D29BFF',
        '#0446D8',
        '#ABE345',
    ].concat(genColor(num));
};
/**
 * 获取一个数字的所有因数（能被整除的数）
 * @param {number} num 目标整数
 * @param {number} global 是否输出全部因数, 默认取差值最小的一对因数
 */
export function factorNumList(num, global = false) {
    if (typeof num === 'number' && Number.isInteger(num)) {
        const nums = [];
        for (let i = 1; i < num + 1; i++) {
            if (nums.includes(i)) {
                break;
            }
            if (num % i === 0) {
                nums.splice(nums.length / 2, 0, i, num / i);
            }
        }
        return global ? nums : nums.slice(nums.length / 2 - 1, nums.length / 2 + 1);
    }
    return [];
}
/**
 * 分离颜色和透明度
 * @param {string} color CSS Hex 或 RGB(A) 颜色值
 * @returns {{color: string, transparent: boolean, opacity: number}}
 */
export function colorParser(color) {
    if (typeof color === 'string') {
        const _string = color.replace(/\s/g, '').toLowerCase();
        // RGB(A) 颜色值
        if (/^rgba?\(\d+,\d+,\d+(?:,[^,]*)?\)$/.test(_string)) {
            let split = _string.split(',');
            if (split.length > 3) {
                let alpha = parseFloat(split.pop());
                let opacity = Number.isNaN(alpha) ? 1 : alpha;
                return {
                    color: split.join(',') + ')',
                    transparent: opacity < 1,
                    opacity,
                };
            } else {
                return {
                    color: _string,
                    transparent: false,
                    opacity: 1,
                };
            }
        }
        // Hex 颜色值
        if (/^#(?:(?:[0-9a-f]{3,4})|(?:[0-9a-f]{6})|(?:[0-9a-f]{8}))$/.test(_string)) {
            let slice = _string.slice(1);
            if (slice.length > 5) {
                let alphaHex = parseInt(slice.slice(6), 16);
                let opacity = Number.isNaN(alphaHex) ? 1 : alphaHex / 255;
                return {
                    color: '#' + slice.slice(0, 6),
                    transparent: opacity < 1,
                    opacity,
                };
            } else {
                let alphaHex = parseInt(slice.slice(3), 16);
                let opacity = Number.isNaN(alphaHex) ? 1 : alphaHex / 15;
                return {
                    color: '#' + slice.slice(0, 3),
                    transparent: opacity < 1,
                    opacity,
                };
            }
        }
    }
    return { color, transparent: false, opacity: 1 };
}

export function isNumber(val) {
    return typeof val === 'number' && !Number.isNaN(val);
}

export function isVector3(val) {
    return Array.isArray(val) && val.length === 3 && val.every(isNumber);
}

export function isObject(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
}
/**
 * 数组替换填充
 * @param {any[]} originArr 被修改的数组
 * @param {any[] | any} data 修改的目标值，回调函数的值会被执行得到返回值
 * @returns {any[]} 返回处理后的数组
 */
export function replaceAllByIndex(originArr, data) {
    if (!!data) {
        if (Array.isArray(data)) {
            for (let i = 0; i < originArr.length; i++) {
                if (i > data.length - 1) break;
                const item = originArr[i];
                const dataItem = typeof data[i] === 'function' ? data[i](item, i) : data[i];
                originArr[i] = dataItem || item;
            }
        } else {
            if (typeof data === 'function') {
                for (let i = 0; i < originArr.length; i++) {
                    const item = originArr[i];
                    originArr[i] = data(item, i) || item;
                }
            } else {
                originArr.fill(data);
            }
        }
    }
    return originArr;
}
